<template>
  <div
    class="c-stream-group-label"
    :class="componentClass"
  >
    <OrganisationTeamsSelector
      v-if="showOrganisationTeamsSelector"
      v-model:team-ids="handleOrganisationTeamIds"
    />
    <BaseInputText
      v-model="handleLabel"
      :aria-label="$t('stream_group_label.label')"
      data-testid="stream-group-label-input"
      :disabled="disabled"
      :label="$t('stream_group_label.group_label')"
      new-design
      :placeholder="placeholder || $t('stream_group_label.add_label')"
      :validations="['notBlank']"
    />
    <BaseInputWrapper
      v-model="handleColor"
      :aria-label="$t('stream_group_label.mention_stream_colour')"
      :label="$t('stream_group_label.group_color')"
      new-design
      :validations="['isColor']"
    >
      <template #control>
        <BaseColorPicker
          v-model="handleColor"
          :disabled="disabled"
          has-color-selector
          new-design
        />
      </template>

      <template
        v-if="!hideColorPickerLabel"
        #after
      >
        <div class="field-subtext q-mt-sm">
          {{ $t("stream_group_label.colour_helps_identify_group") }}
        </div>
      </template>
    </BaseInputWrapper>
  </div>
</template>

<script>
import {
  BaseColorPicker,
  BaseInputText,
  BaseInputWrapper,
} from "shared/components/base";
import OrganisationTeamsSelector from "shared/components/user/OrganisationTeamsSelector.vue";

export default {
  name: "StreamGroupLabel",
  components: {
    BaseColorPicker,
    BaseInputText,
    BaseInputWrapper,
    OrganisationTeamsSelector,
  },
  props: {
    label: {
      type: String,
      default: "",
    },
    color: {
      type: String,
      default: "silver",
    },
    placeholder: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
    },
    hideColorPickerLabel: {
      type: Boolean,
    },
    spacing: {
      type: String,
      default: "xl",
    },
    organisationTeamIds: {
      type: Array,
      default: () => [],
    },
    showOrganisationTeamsSelector: {
      type: Boolean,
    },
  },
  emits: ["update:color", "update:label", "update:organisationTeamIds"],
  computed: {
    handleColor: {
      get() {
        return this.color;
      },
      set(val) {
        this.$emit("update:color", val);
      },
    },
    handleLabel: {
      get() {
        return this.label;
      },
      set(val) {
        this.$emit("update:label", val);
      },
    },
    handleOrganisationTeamIds: {
      get() {
        return this.organisationTeamIds;
      },
      set(val) {
        this.$emit("update:organisationTeamIds", val);
      },
    },
    componentClass() {
      return `c-stream-group-label--spacing-${this.spacing}`;
    },
  },
};
</script>

<style lang="scss">
.c-stream-group-label {
  --spacing: var(--s-spacing-xl);

  gap: var(--spacing);
  display: grid;

  &--spacing-lg {
    --spacing: var(--s-spacing-lg);
  }
}
</style>
